import { useState, useEffect } from "react";

export function useStickyState(defaultValue, key) {
  const [value, setValue] = useState(() => {
    try {
      const stickyValue = window.sessionStorage.getItem(key);
      return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
    } catch (err) {
      console.warn(`Error reading sessionStorage for key "${key}":`, err);
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.warn(`Error setting sessionStorage for key "${key}":`, err);
    }
  }, [key, value]);

  return [value, setValue];
}
